const RoleGridPluginSettings: IPluginSettings = {
    name: 'Роли',
    mnemocode: 'role_plugin',
    permission: 'Role',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'ID',
        visibility: false,
        width: 150
    }, {
        order: 1,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Роль',
        visibility: true,
        width: 150
    }, {
        order: 2,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 150
    },
    {
        order: 3,
        propertyName: 'deleted',
        propertyType: 'boolean',
        displayName: 'Удалено',
        visibility: false,
        width: 100
    },
    {
        order: 4,
        propertyName: 'dateCreated',
        propertyType: 'datetime',
        displayName: 'Дата создания',
        visibility: true,
        width: 100
    },
    {
        order: 5,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 100
    },
    ]
}

export default RoleGridPluginSettings